import { render, staticRenderFns } from "./groupNode1.vue?vue&type=template&id=4bd10bd4&"
import script from "./groupNode1.vue?vue&type=script&lang=ts&"
export * from "./groupNode1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports